import { FreelyPaymentError, StripePaymentError } from './errorClasses';

const IGNORABLE_STRIPE_ERROR_TYPES = [
  'InputError',
  'CancelWalletPayment',
  'ConfirmPayment',
] as const;

const IGNORABLE_STRIPE_ERROR_MESSAGES = ['Your card’s CVC is incorrect.', 'Invalid Card'] as const;

export function canIgnoreStripeErrors(e: unknown): boolean {
  const isStripePaymentError = e instanceof StripePaymentError;
  const isFreelyPaymentError = e instanceof FreelyPaymentError;
  if (!(isFreelyPaymentError || isStripePaymentError)) {
    return false;
  }
  const hasIgnorableType = IGNORABLE_STRIPE_ERROR_TYPES.some(errorMessage =>
    e.name?.includes(errorMessage),
  );
  const hasIgnorableMessage = IGNORABLE_STRIPE_ERROR_MESSAGES.some(errorMessage =>
    e.message?.includes(errorMessage),
  );
  return hasIgnorableType || hasIgnorableMessage;
}
